import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textMark'
})
export class TextMarkPipe implements PipeTransform {

  constructor() {}

  transform(value: string, text: string): string {
    const textParts: Array<string> = text.split(' ');
    if (Array.isArray(textParts) && textParts.length > 0) {
      textParts.forEach((textPart: string) => {
        const pattern = '(.*)(' + textPart.replace(/[\+\-\*]/, '') + ')(.*)';
        const regex = new RegExp(pattern, 'i');
        const found = value.match(regex);
        if (found !== null && found.length === 4) {
          value = found[1] + '<i>' + found[2] + '</i>' + found[3];
        }
      });
    }
    return value;
  }

}
